module.exports = __webpack_public_path__ + "static/logo-forbes-2144eb8d7441522d63078b6930501095.svg";